export default __webpack_public_path__ + "static/media/information--trucks-only--g1.979028f2.png";